import React, { useEffect } from "react";
import ProductList from "../components/ProductList";
import { useParams } from "react-router-dom";

const ListPage = () => {
    const { slug } = useParams()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [slug])

    return (
        <>
            <ProductList />
        </>
    )
}

export default ListPage;